<template>
  <div>
    <h1 align="center">{{ msg }}</h1>

    <Row type="flex" justify="center" :gutter="24" style="margin-top: 50px">

      <Col :xs="24" :sm=24 :md="8" :xl="6" v-for="item in buttons" :key="item.msg">
        <Card
          style="cursor: pointer"
          class="card-container"
          @click.native="$router.push({ name: item.view_name, query: item.params })">

          <img :src="item.img" alt="" class="background-img">

          <div class="z-index-2">
            <h2 class="mb-30">{{ item.msg }}</h2>
            <span class="fs-16">
              {{ item.description }}
            </span>

          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
    // import topProductsChart from "./topProductsChart";
    // import averageOrderChart from "./averageOrderChart";
    // import revenueChart from "./revenueChart";
    // import paymentType from "./paymentType";

    export default {
        name: "moneyOrderActions",

        data() {
            return {
                msg: "Выберите действие:",
                buttons: [
                    {
                        msg: "Приход",
                        description: "Создание документа для отражения поступления денежных средств",
                        view_name: "money_order_create",
                        params: {type: "coming"},
                        img: '/static/img/action_img/img-1.png'
                    },
                    {
                        msg: "Расход",
                        description: "Создание документа для отражения выбытия денежных средств",
                        view_name: "money_order_create",
                        params: {type: "outgoing"},
                        img: '/static/img/action_img/img-3.png'
                    },
                    {
                        msg: "Перевод",
                        description: "Создание документа для перевода денежных средств внутри своих собственных счетов",
                        view_name: "money_order_create_transfer",
                        params: {},
                        img: '/static/img/action_img/img-5.png'
                    },
                ]
            };
        }
    };
</script>

<style scoped>
  .card-container {
    position: relative;
    background-color: #F1F1F1;
    text-align: left;
    padding: 24px;
    width: 100%;
    min-height: 225px;
    cursor: pointer;
    /*margin: 10px*/
    margin-bottom: 40px;
    border: none;
  }

  .card-container span {
    transition: 0.3s ease-in;
    padding-right: 30%;
    display: block;
  }

  .background-img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .z-index-2 {
    position: relative;
    z-index: 2;
  }

  .card-container:hover {
    background-color: #1DBDC6;

  }

  .card-container:hover h2, .card-container:hover span {
    color: #ffffff
  }

  @media screen and (max-width: 1500px) {
    .card-container {
      padding: 15px 0;
    }
  }

  @media screen and (max-width: 1365px) {
    .background-img {
      height: 70%;
    }
  }


</style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrderActions.vue